// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4q-0";
export var eligibilityCardNotEligible = "_4q-1";